import React from "react";
import {useTranslation} from "react-i18next";
import {getFormattedDateTime} from "@ots-frontend/ots-data";
export {getFormattedDateTime} from "@ots-frontend/ots-data";

export interface FormattedDateTimeProps {
    date: Date | number | undefined;
    displayTime?: boolean;
    displaySeconds?: boolean;
    style?: React.CSSProperties;
}

export const FormattedDateTime = (props: FormattedDateTimeProps) => {
    const {style, date, displaySeconds, displayTime = true} = props;

    const {t} = useTranslation(["common"]);

    if (date == null) {
        return (
            <span style={style}>
                {t("common.notapplicable")}
            </span>
        );
    }

    return (
        <span style={style}>
          <span style={{marginRight: "5px"}}>
            {getFormattedDateTime(date, displayTime, displaySeconds)}
          </span>
        </span>
    );
};
